var render = function render(_c,_vm){return _c('div',{class:[_vm.props.small ? 'tiles-sm' : 'tiles',
   _vm.props.square ? 'tiles-square' : 'tiles-rect', {'tiles-hs' : _vm.props.allowHScroll}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }